<template>
    <div class="data-assets-manage">
        <!-- 统计卡片 -->
        <div class="stats-row">
            <div class="stat-card stat-total">
                <div class="stat-icon-wrap">
                    <i class="el-icon-document"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.totalCount }}</div>
                    <div class="stat-desc">提交总数</div>
                </div>
            </div>
            <div class="stat-card stat-approved">
                <div class="stat-icon-wrap">
                    <i class="el-icon-circle-check"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.approvalCount }}</div>
                    <div class="stat-desc">审核完成</div>
                </div>
            </div>
            <div class="stat-card stat-pending">
                <div class="stat-icon-wrap">
                    <i class="el-icon-time"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-number">{{ countData.underApprovalCount }}</div>
                    <div class="stat-desc">待审核</div>
                </div>
            </div>
        </div>

        <!-- 查询区域 -->
        <el-card class="search-card" shadow="never">
            <el-form :inline="true" :model="queryForm">
                <el-form-item label="登记编号">
                    <el-input v-model="queryForm.registrationId" placeholder="请输入" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="企业名称">
                    <el-input v-model="queryForm.companyName" placeholder="请输入" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="资产名称">
                    <el-input v-model="queryForm.assetName" placeholder="请输入" clearable style="width: 180px;"></el-input>
                </el-form-item>
                <el-form-item label="登记类型">
                    <el-select v-model="queryForm.type" placeholder="请选择" style="width: 140px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="初始登记" value="初始登记"></el-option>
                        <el-option label="许可登记" value="许可登记"></el-option>
                        <el-option label="变更登记" value="变更登记"></el-option>
                        <el-option label="转移登记" value="转移登记"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryForm.status" placeholder="请选择" style="width: 140px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="待初审" value="待初审"></el-option>
                        <el-option label="待复审" value="待复审"></el-option>
                        <el-option label="初审驳回" value="初审驳回"></el-option>
                        <el-option label="复审驳回" value="复审驳回"></el-option>
                        <el-option label="终审驳回" value="终审驳回"></el-option>
                        <el-option label="未颁发证书" value="未颁发证书"></el-option>
                        <el-option label="已颁发证书" value="已颁发证书"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 数据表格 -->
        <el-card class="table-card" shadow="never">
            <el-table :data="tableData" border
                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
                style="width: 100%;">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="registrationId" label="登记编号" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetName" label="资产名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="companyName" label="企业名称" min-width="200" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="登记类型" width="100" align="center">
                    <template slot-scope="scope">{{ formatType(scope.row.registrationType) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusTagType(scope.row.authState)" size="small" effect="light">
                            {{ formatStatus(scope.row.authState) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="登记时间" width="170" align="center"></el-table-column>
                <el-table-column prop="reviewTime" label="审核时间" width="170" align="center"></el-table-column>
                <el-table-column label="操作" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                    layout="total, sizes, prev, pager, next"
                    :total="boardsTotal"
                    :page-size="pageSize"
                    :current-page="currPage"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "DataAssetsManage",
    components: { AddBoardContent },
    data() {
        return {
            boardsTotal: 0,
            currPage: 1,
            pageSize: 10,
            queryForm: {
                registrationId: '',
                companyName: '',
                assetName: '',
                type: '全部',
                status: '全部'
            },
            countData: {
                totalCount: 0,
                approvalCount: 0,
                underApprovalCount: 0
            },
            tableData: [],
            currentName: ''
        }
    },
    mounted() {
        this.fetchCountData();
        this.initTableData();
    },
    methods: {
        fetchCountData() {
            this.getRequest('/web/dataAssets/queryCount').then(resp => {
                if (resp && resp.data) {
                    this.countData = resp.data;
                }
            });
        },
        initTableData() {
            this.getRequest('/web/dataAssets/review/getList?registrationId=' + this.queryForm.registrationId
                + '&companyName=' + this.queryForm.companyName
                + '&assetName=' + this.queryForm.assetName
                + '&registrationType=' + (this.queryForm.type === '全部' ? '' : this.queryForm.type)
                + '&state=' + (this.queryForm.status === '全部' ? '' : this.queryForm.status)
                + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                    if (resp && resp.data) {
                        this.boardsTotal = resp.data.total;
                        this.tableData = resp.data.list;
                    }
                });
        },
        doSearch() {
            this.currPage = 1;
            this.initTableData();
        },
        resetSearch() {
            this.queryForm = { registrationId: '', companyName: '', assetName: '', type: '全部', status: '全部' };
            this.currPage = 1;
            this.initTableData();
        },
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currPage = 1;
            this.initTableData();
        },
        formatType(type) {
            const types = { '1': '初始登记', '2': '许可登记', '3': '变更登记', '4': '转移登记' };
            return types[type] || type;
        },
        formatStatus(status) {
            const statusMap = {
                '0': '待审核', '1': '初审通过', '2': '复审通过', '3': '终审通过',
                '4': '初审驳回', '5': '复审驳回', '6': '终审驳回'
            };
            return statusMap[status] || status;
        },
        getStatusTagType(status) {
            const s = this.formatStatus(status);
            if (s === '审核公示中') return 'success';
            if (s === '已颁发证书') return '';
            if (s.includes('驳回')) return 'danger';
            if (s === '待审核') return 'info';
            return 'warning';
        },
        handleDetail(row) {
            this.$router.push({
                path: '/index/company/review-manage',
                query: { registrationId: row.registrationId, formData: JSON.stringify(row) }
            });
        },
        changeName(name) {
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleEdit(obj) {
            this.currentName = 'AddBoardContent';
            this.$store.commit('ADD_CURRENT_BOARD_ID', obj.id);
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRequest("/web/board/" + obj.id).then(resp => {
                    this.initTableData('');
                });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {});
        },
        goToRegistration() {
            this.$router.push('/index/data-registration');
        },
        handleReview(row) {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.id) {
                    throw new Error('无法获取用户信息');
                }
                this.$router.push({
                    path: '/index/company/data-review',
                    query: { id: row.dataAssetsId || row.id, formData: JSON.stringify(row) }
                });
            } catch (error) {
                console.error('跳转审核页面失败:', error);
                this.$message.error('跳转审核页面失败: ' + error.message);
            }
        }
    }
}
</script>

<style scoped>
.data-assets-manage {
    padding: 20px 24px;
    background: #f0f2f5;
    min-height: 100%;
}

.stats-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
}

.stat-card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    background: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border-left: 4px solid transparent;
    transition: box-shadow 0.2s;
}

.stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-total { border-left-color: #409EFF; }
.stat-approved { border-left-color: #67C23A; }
.stat-pending { border-left-color: #E6A23C; }

.stat-icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}

.stat-total .stat-icon-wrap { background: #ecf5ff; color: #409EFF; }
.stat-approved .stat-icon-wrap { background: #f0f9eb; color: #67C23A; }
.stat-pending .stat-icon-wrap { background: #fdf6ec; color: #E6A23C; }

.stat-number {
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
}

.stat-total .stat-number { color: #409EFF; }
.stat-approved .stat-number { color: #67C23A; }
.stat-pending .stat-number { color: #E6A23C; }

.stat-desc {
    font-size: 13px;
    color: #909399;
}

.search-card {
    margin-bottom: 16px;
    border-radius: 10px;
    border: none;
}

.search-card >>> .el-card__body {
    padding: 16px 20px 4px;
}

.search-card >>> .el-form-item {
    margin-bottom: 12px;
    margin-right: 16px;
}

.table-card {
    border-radius: 10px;
    border: none;
}

.table-card >>> .el-card__body {
    padding: 16px 20px;
}

.table-card >>> .el-table th {
    font-weight: 600;
}

.table-card >>> .el-table td {
    padding: 10px 0;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>
